import type { ChatAgentMessage } from '@/gql/graphql';

import type { ChatMessage, ContentBlock } from './types';

/**
 * Transforms a persisted ChatAgentMessage from GraphQL into a frontend ChatMessage.
 */
export function transformPersistedMessage(msg: ChatAgentMessage): ChatMessage {
  const isAssistant = msg.role === 'ASSISTANT';

  const contentBlocks: ContentBlock[] = msg.content
    ? [{ type: 'text', text: msg.content }]
    : [];

  return {
    id: msg.id,
    role: msg.role.toLowerCase() as 'user' | 'assistant',
    content: msg.content,
    timestamp: new Date(msg.createdAt),
    isStreaming: false,
    contentBlocks: isAssistant ? contentBlocks : undefined,
  };
}
